import { ExternalLink } from "@/components/ui/button/external-link";
import LightBulbIcon from "@/components/ui/icon/lightbulb";

export const AboutRecommendedTagFeedback = () => (
	<div className="rounded-md bg-zinc-100 p-4">
		<div className="flex gap-x-3">
			<div className="flex-shrink-0">
				<LightBulbIcon />
			</div>

			<div className="text-sm text-zinc-700">
				<p>
					CHILLNNが運用する
					<ExternalLink
						className="h-auto text-sm"
						href="https://www.chillnn.com/?inflowfrom=MAGAZINE_MEDIA"
						text="ギャラリー"
					/>
					内で記事が検索される際に使用されるタグです。掲載をご希望の場合は、別途ご連絡ください。
				</p>
			</div>
		</div>
	</div>
);
